import { useState, useEffect, useCallback } from 'react';
import DynaSpan from '../components/DynaSpan';
import { Accordion, Button } from 'react-bootstrap';
import DynaLoader from '../components/DynaLoader';
import { getContract } from '../utils/BlockchainAPI';
import { handleError } from '../utils/ErrorHandler';
import { Form } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import { OverlayTrigger } from 'react-bootstrap';
import { Tooltip } from 'react-bootstrap';
// import { create } from 'ipfs-http-client';
import { useParams } from 'react-router-dom';

import DynaStripesContractAddress, { DynaStripesCurrentNetworkExplorerUrl } from '../utils/Constants';
import { fetchTokenMetadata } from '../utils/TokenMetadata';
import { convertSvgToPng } from '../utils/UIUtils';
import opensea from '../images/opensea.svg';
import twitter from '../images/twitter.png';

const TokenPage = () => {
  const { tokenId } = useParams<{ tokenId: string }>();

  const [loading, setLoading] = useState(true);
  const [tokenOwner, setTokenOwner] = useState(null);
  const [tokenSvgDataUri, setTokenSvgDataUri] = useState(null);
  const [tokenSvgFileName, setTokenSvgFileName] = useState(null);
  const [tokenPngDataUri, setTokenPngDataUri] = useState(null);
  const [tokenPngFileName, setTokenPngFileName] = useState(null);
  const [descriptiveTraits, setDescriptiveTraits] = useState(null);
  const [tokenTraits, setTokenTraits] = useState(null);

  const fetchMetadata = useCallback(async () => {
    console.log("Getting SVG for token ID: " + tokenId);

    try {
      // Owner can change hands, so it stays a live read; the art can't, so it
      // comes from the shared cache. Both go out at once.
      const contract = await getContract();
      const [owner, metadata] = await Promise.all([
        contract.ownerOf(tokenId),
        fetchTokenMetadata(tokenId as string),
      ]);

      const encodedSvgDataUri = metadata.svgDataUri;
      const pngDataUri = await convertSvgToPng(metadata.svg);

      const filePrefix = "DynaStripes" + tokenId;
      const svgFileName = filePrefix + ".svg";
      const pngFileName = filePrefix + ".png";

      const attributes = metadata.attributes;
      const descriptiveText = metadata.traitsText;

      setTokenOwner(owner);
      setTokenSvgDataUri(encodedSvgDataUri);
      setTokenSvgFileName(svgFileName);
      setTokenPngDataUri(pngDataUri);
      setTokenPngFileName(pngFileName);
      setDescriptiveTraits(descriptiveText);
      setTokenTraits(attributes);
      setLoading(false);

    } catch (err) {
      handleError(err);
    }
  }, [tokenId]);

  useEffect(() => {
    fetchMetadata();
  }, [fetchMetadata]);

  // const convertDataURIToBinary = (dataURI) => {
  //   var BASE64_MARKER = ';base64,';
  //   var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  //   var base64 = dataURI.substring(base64Index);
  //   var raw = window.atob(base64);
  //   var rawLength = raw.length;
  //   var array = new Uint8Array(new ArrayBuffer(rawLength));
  //
  //   for (var i = 0; i < rawLength; i++) {
  //     array[i] = raw.charCodeAt(i);
  //   }
  //   return array;
  // };

  // downloadSvg() {
  //     const link = document.createElement("a");
  //     link.href = this.state.tokenSvgDataUri;
  //     link.download = "DynaStripes" + this.state.tokenId +".svg";
  //     link.click();
  // }

  // downloadPng() {
  //
  //   // showInfoMessage("Save PNG functionality coming soon!");
  //
  //   const link = document.createElement("a");
  //   link.href = this.state.tokenPngUrl;
  //   link.download = "DynaStripes" + this.state.tokenId +".png";
  //   link.click();
  //
  // }

  if (loading === true) {
    return (
      <div className="mainContent">
        <div className="content">
          <h1><DynaSpan /> token #{tokenId}</h1>
          <div className="deepContent">
            <center>
              <DynaLoader variant="block" />
            </center>
          </div>
        </div>
      </div>
    );
  }

  let ethAddress = tokenOwner;
  const etherscanLink = DynaStripesCurrentNetworkExplorerUrl + "address/" + ethAddress;

  if (ethAddress.length > 10) {
    ethAddress = ethAddress.substring(0, 6) + "..." + ethAddress.slice(-4);
  }

  const openSeaLink = "https://opensea.io/assets/matic/" + DynaStripesContractAddress + "/" + tokenId;

  const renderSvgTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      animated scalable vector image -- best quality at various sizes
    </Tooltip>
  );

  const renderPngTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      still, fixed-size raster image -- nonanimated first frame of image, good for web, but won't scale well
    </Tooltip>
  );

  const tokenPageLink = encodeURIComponent("https://www.dynastripes.xyz/token/" + tokenId);
  const tweetText = encodeURIComponent("Check out this generative, 100% on-chain DynaStripes #NFT artwork!");
  const tweetRelated = encodeURIComponent("volstrate,richardrauser");
  const tweetUrl = "https://twitter.com/intent/tweet?url=" + tokenPageLink + "&text=" + tweetText + "&related=" + tweetRelated;

  return (
    <div className="mainContent">
      <title>{`DynaStripes Artwork ${tokenId}`}</title>
      <meta property="twitter:title" content="DynaStripes Artwork" />
      <meta property="twitter:image:alt" content="DynaStripes Artwork" />
      <meta property="og:title" content="DynaStripes Artwork" />
      <div className="content">
        <h1><DynaSpan /> token #{tokenId}</h1>
        <div className="deepContent">
          <div className="singleArtwork">
            <img alt={"DynaStripes token " + tokenId} src={tokenSvgDataUri} />
          </div>

          <div className="singleArtworkDetail">
            {descriptiveTraits} <br />
            Owned by: <a href={etherscanLink} target="_blank" rel="noreferrer">  {ethAddress} </a> <br />
          </div>

          <div className="actions">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                Save Image
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 50, hide: 400 }}
                  overlay={renderSvgTooltip}>
                  <Dropdown.Item href={tokenSvgDataUri} download={tokenSvgFileName}>animated SVG</Dropdown.Item>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 50, hide: 400 }}
                  overlay={renderPngTooltip}>
                  <Dropdown.Item href={tokenPngDataUri} download={tokenPngFileName}>still PNG</Dropdown.Item>
                </OverlayTrigger>
              </Dropdown.Menu>
            </Dropdown>

            <Button href={openSeaLink} target="_blank" rel="noreferrer">
              <img className="buttonLogo" alt="opensea logo" src={opensea} />
              OpenSea
            </Button>

            <a href={tweetUrl} target="_blank" rel="noreferrer">
              <Button>
                <img className="buttonLogo" alt="twitter logo" src={twitter} />
                Tweet
              </Button>
            </a>
          </div>

          <Accordion className="singleArtworkTraitsAccordion">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Traits JSON</Accordion.Header>
              <Accordion.Body>
                <Form.Control className="traits" as="textarea" readOnly={true} rows={10} value={JSON.stringify(tokenTraits, null, 2)} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

        </div>
      </div>

    </div>
  );
}

export default TokenPage;